import { faker } from '@faker-js/faker'

import {
  ChangeReservationTimeCommand,
  MakeReservationJpCommand,
  MakeReservationKrCommand,
  TryReservationCommand,
} from '../../contracts/reservation'

export const getReservationKrRequestCommandFixture = (): MakeReservationKrCommand => {
  return {
    progressId: faker.datatype.uuid(),
    memberId: faker.number.int(),
    serviceOfferId: faker.number.int(),
    slotId: faker.number.int(),
    serviceOfferTitle: faker.lorem.paragraph(),
    memberName: faker.person.fullName(),
    memberPhoneCountryCode: '82',
    memberPhoneNational: faker.phone.number(),
    memberEmail: faker.internet.email(),
    memberBirthYear: 1999,
  }
}

export const getReservationJpRequestCommandFixture = (): MakeReservationJpCommand => {
  return {
    userInfo: {
      name: faker.lorem.word(),
      phoneNational: faker.phone.number(),
      birthYear: faker.date.past().getFullYear(),
      birthMonth: faker.date.past().getMonth(),
      birthDay: faker.date.past().getDay(),
      sex: faker.helpers.arrayElement(['MALE', 'FEMALE', 'ANY']),
      email: faker.internet.email(),
      deviceType: faker.helpers.arrayElement(['IOS', 'ANDROID', 'WEB']),
    },
    hospitalId: faker.number.int(),
    slotId: faker.number.int(),
    requestedReservedAt: faker.date.future().toString(), // '2021-01-01T00:00:00.000Z'
    origin: {
      type: 'EVENT',
      id: faker.number.int(),
    },
  }
}

export const getTryReservationRequestCommandFixture = (): TryReservationCommand => {
  return {
    progressId: faker.datatype.uuid(),
    serviceOfferId: faker.number.int(),
    slotId: faker.number.int(),
    memberName: faker.person.fullName(),
    memberPhoneCountryCode: '82',
    memberPhoneNational: faker.phone.number(),
    memberEmail: faker.internet.email(),
    hospitalId: faker.number.int(),
    requestedReservedAt: faker.date.future().toString(), // '2021-01-01T00:00:00.000Z'
  }
}

export const getChangeReservationTimeCommandFixture = (): ChangeReservationTimeCommand => ({
  reservationId: faker.number.int(),
  slotId: faker.number.int(),
  eventTitle: faker.lorem.paragraph(),
  birthYear: faker.date.birthdate().getFullYear(),
  startDateTimeUtc: faker.date.future().toString(), // '2021-01-01T00:00:00.000Z'
  endDateTimeUtc: faker.date.future().toString(), // '2021-01-01T00:00:00.000Z'
})
